import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './sessionWithMenuItemCartQuery.gql';
import { SessionFragmentDoc } from '../../fragments/users/SessionFragment.generated';
import { MenuItemCartWithMenusFragmentDoc } from '../../fragments/menu_item_carts/MenuItemCartWithMenusFragment.generated';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_uiItem_UiMenuItemAloha = {
  __typename: 'UiMenuItemAloha',
  id: string,
  canBeDeleted: boolean,
  canBeDisabled: boolean,
  canBeDragged: boolean,
  modGroupsCanBeDragged: boolean,
  canUpdateContainsAlcohol: boolean,
  canUpdateOutOfStock: boolean,
  isItemHasBlockingSyncWarning: boolean,
  isItemLocationSquare: boolean,
  isItemLocationToast: boolean,
  isItemAttachedToPos: boolean,
  isItemNcrSilver: boolean,
  isItemSquare: boolean,
  isItemToast: boolean,
  isItemDeliverect: boolean,
  isItemCustomPriceType: boolean,
  hasDishMismatchedExtras: boolean,
  hasDishMismatchedSizes: boolean,
  hasDishMismatchedExtraGroups: boolean,
  hasDishMismatchedSharedExtraGroups: boolean,
  showItemNotAttachedWarning: boolean,
  syncedAt?: string | null,
  sizeVariationCanBeChanged: boolean,
  showSyncTab: boolean
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_uiItem_UiMenuItemBase = {
  __typename: 'UiMenuItemBase',
  id: string,
  canBeDeleted: boolean,
  canBeDisabled: boolean,
  canBeDragged: boolean,
  modGroupsCanBeDragged: boolean,
  canUpdateContainsAlcohol: boolean,
  canUpdateOutOfStock: boolean,
  isItemHasBlockingSyncWarning: boolean,
  isItemLocationSquare: boolean,
  isItemLocationToast: boolean,
  isItemAttachedToPos: boolean,
  isItemNcrSilver: boolean,
  isItemSquare: boolean,
  isItemToast: boolean,
  isItemDeliverect: boolean,
  isItemCustomPriceType: boolean,
  hasDishMismatchedExtras: boolean,
  hasDishMismatchedSizes: boolean,
  hasDishMismatchedExtraGroups: boolean,
  hasDishMismatchedSharedExtraGroups: boolean,
  showItemNotAttachedWarning: boolean,
  syncedAt?: string | null,
  sizeVariationCanBeChanged: boolean,
  showSyncTab: boolean
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_uiItem_UiMenuItemClover = {
  __typename: 'UiMenuItemClover',
  id: string,
  canBeDeleted: boolean,
  canBeDisabled: boolean,
  canBeDragged: boolean,
  modGroupsCanBeDragged: boolean,
  canUpdateContainsAlcohol: boolean,
  canUpdateOutOfStock: boolean,
  isItemHasBlockingSyncWarning: boolean,
  isItemLocationSquare: boolean,
  isItemLocationToast: boolean,
  isItemAttachedToPos: boolean,
  isItemNcrSilver: boolean,
  isItemSquare: boolean,
  isItemToast: boolean,
  isItemDeliverect: boolean,
  isItemCustomPriceType: boolean,
  hasDishMismatchedExtras: boolean,
  hasDishMismatchedSizes: boolean,
  hasDishMismatchedExtraGroups: boolean,
  hasDishMismatchedSharedExtraGroups: boolean,
  showItemNotAttachedWarning: boolean,
  syncedAt?: string | null,
  sizeVariationCanBeChanged: boolean,
  showSyncTab: boolean
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_uiItem_UiMenuItemDeliverect = {
  __typename: 'UiMenuItemDeliverect',
  id: string,
  canBeDeleted: boolean,
  canBeDisabled: boolean,
  canBeDragged: boolean,
  modGroupsCanBeDragged: boolean,
  canUpdateContainsAlcohol: boolean,
  canUpdateOutOfStock: boolean,
  isItemHasBlockingSyncWarning: boolean,
  isItemLocationSquare: boolean,
  isItemLocationToast: boolean,
  isItemAttachedToPos: boolean,
  isItemNcrSilver: boolean,
  isItemSquare: boolean,
  isItemToast: boolean,
  isItemDeliverect: boolean,
  isItemCustomPriceType: boolean,
  hasDishMismatchedExtras: boolean,
  hasDishMismatchedSizes: boolean,
  hasDishMismatchedExtraGroups: boolean,
  hasDishMismatchedSharedExtraGroups: boolean,
  showItemNotAttachedWarning: boolean,
  syncedAt?: string | null,
  sizeVariationCanBeChanged: boolean,
  showSyncTab: boolean
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_uiItem_UiMenuItemHeartlandPos = {
  __typename: 'UiMenuItemHeartlandPos',
  id: string,
  canBeDeleted: boolean,
  canBeDisabled: boolean,
  canBeDragged: boolean,
  modGroupsCanBeDragged: boolean,
  canUpdateContainsAlcohol: boolean,
  canUpdateOutOfStock: boolean,
  isItemHasBlockingSyncWarning: boolean,
  isItemLocationSquare: boolean,
  isItemLocationToast: boolean,
  isItemAttachedToPos: boolean,
  isItemNcrSilver: boolean,
  isItemSquare: boolean,
  isItemToast: boolean,
  isItemDeliverect: boolean,
  isItemCustomPriceType: boolean,
  hasDishMismatchedExtras: boolean,
  hasDishMismatchedSizes: boolean,
  hasDishMismatchedExtraGroups: boolean,
  hasDishMismatchedSharedExtraGroups: boolean,
  showItemNotAttachedWarning: boolean,
  syncedAt?: string | null,
  sizeVariationCanBeChanged: boolean,
  showSyncTab: boolean
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_uiItem_UiMenuItemMicros = {
  __typename: 'UiMenuItemMicros',
  id: string,
  canBeDeleted: boolean,
  canBeDisabled: boolean,
  canBeDragged: boolean,
  modGroupsCanBeDragged: boolean,
  canUpdateContainsAlcohol: boolean,
  canUpdateOutOfStock: boolean,
  isItemHasBlockingSyncWarning: boolean,
  isItemLocationSquare: boolean,
  isItemLocationToast: boolean,
  isItemAttachedToPos: boolean,
  isItemNcrSilver: boolean,
  isItemSquare: boolean,
  isItemToast: boolean,
  isItemDeliverect: boolean,
  isItemCustomPriceType: boolean,
  hasDishMismatchedExtras: boolean,
  hasDishMismatchedSizes: boolean,
  hasDishMismatchedExtraGroups: boolean,
  hasDishMismatchedSharedExtraGroups: boolean,
  showItemNotAttachedWarning: boolean,
  syncedAt?: string | null,
  sizeVariationCanBeChanged: boolean,
  showSyncTab: boolean
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_uiItem_UiMenuItemNcrSilver = {
  __typename: 'UiMenuItemNcrSilver',
  id: string,
  canBeDeleted: boolean,
  canBeDisabled: boolean,
  canBeDragged: boolean,
  modGroupsCanBeDragged: boolean,
  canUpdateContainsAlcohol: boolean,
  canUpdateOutOfStock: boolean,
  isItemHasBlockingSyncWarning: boolean,
  isItemLocationSquare: boolean,
  isItemLocationToast: boolean,
  isItemAttachedToPos: boolean,
  isItemNcrSilver: boolean,
  isItemSquare: boolean,
  isItemToast: boolean,
  isItemDeliverect: boolean,
  isItemCustomPriceType: boolean,
  hasDishMismatchedExtras: boolean,
  hasDishMismatchedSizes: boolean,
  hasDishMismatchedExtraGroups: boolean,
  hasDishMismatchedSharedExtraGroups: boolean,
  showItemNotAttachedWarning: boolean,
  syncedAt?: string | null,
  sizeVariationCanBeChanged: boolean,
  showSyncTab: boolean
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_uiItem_UiMenuItemSquare = {
  __typename: 'UiMenuItemSquare',
  id: string,
  canBeDeleted: boolean,
  canBeDisabled: boolean,
  canBeDragged: boolean,
  modGroupsCanBeDragged: boolean,
  canUpdateContainsAlcohol: boolean,
  canUpdateOutOfStock: boolean,
  isItemHasBlockingSyncWarning: boolean,
  isItemLocationSquare: boolean,
  isItemLocationToast: boolean,
  isItemAttachedToPos: boolean,
  isItemNcrSilver: boolean,
  isItemSquare: boolean,
  isItemToast: boolean,
  isItemDeliverect: boolean,
  isItemCustomPriceType: boolean,
  hasDishMismatchedExtras: boolean,
  hasDishMismatchedSizes: boolean,
  hasDishMismatchedExtraGroups: boolean,
  hasDishMismatchedSharedExtraGroups: boolean,
  showItemNotAttachedWarning: boolean,
  syncedAt?: string | null,
  sizeVariationCanBeChanged: boolean,
  showSyncTab: boolean
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_uiItem_UiMenuItemToast = {
  __typename: 'UiMenuItemToast',
  id: string,
  canBeDeleted: boolean,
  canBeDisabled: boolean,
  canBeDragged: boolean,
  modGroupsCanBeDragged: boolean,
  canUpdateContainsAlcohol: boolean,
  canUpdateOutOfStock: boolean,
  isItemHasBlockingSyncWarning: boolean,
  isItemLocationSquare: boolean,
  isItemLocationToast: boolean,
  isItemAttachedToPos: boolean,
  isItemNcrSilver: boolean,
  isItemSquare: boolean,
  isItemToast: boolean,
  isItemDeliverect: boolean,
  isItemCustomPriceType: boolean,
  hasDishMismatchedExtras: boolean,
  hasDishMismatchedSizes: boolean,
  hasDishMismatchedExtraGroups: boolean,
  hasDishMismatchedSharedExtraGroups: boolean,
  showItemNotAttachedWarning: boolean,
  syncedAt?: string | null,
  sizeVariationCanBeChanged: boolean,
  showSyncTab: boolean
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_uiItem = CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_uiItem_UiMenuItemAloha | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_uiItem_UiMenuItemBase | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_uiItem_UiMenuItemClover | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_uiItem_UiMenuItemDeliverect | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_uiItem_UiMenuItemHeartlandPos | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_uiItem_UiMenuItemMicros | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_uiItem_UiMenuItemNcrSilver | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_uiItem_UiMenuItemSquare | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_uiItem_UiMenuItemToast;

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_availableExternalItems_ExternalMenuItem_menuItem_MenuItem = {
  __typename: 'MenuItem',
  id: number,
  name: string
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_availableExternalItems_ExternalMenuItem = {
  __typename: 'ExternalMenuItem',
  id: number,
  groupName?: string | null,
  integrationType: string,
  menuItemId?: number | null,
  name: string,
  price?: number | null,
  menuItem?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_availableExternalItems_ExternalMenuItem_menuItem_MenuItem | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_section_MenuSection = {
  __typename: 'MenuSection',
  id: number
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_subsection_MenuSubsection = {
  __typename: 'MenuSubsection',
  id: number
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_menu_Menu = {
  __typename: 'Menu',
  id: number,
  cateringLeadTimeMinutes: number,
  isCateringMenu: boolean,
  locationId?: number | null,
  menuType: string
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_dish_Dish_allSelectedDishTags_DishTagObject = {
  __typename: 'DishTagObject',
  id: string,
  abbr: string,
  color: string,
  imageIconUrl?: string | null,
  name: string
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_dish_Dish = {
  __typename: 'Dish',
  id: number,
  restaurantId?: number | null,
  featured?: boolean | null,
  isCreatedByMenuSync?: boolean | null,
  updateInProgress?: boolean | null,
  allSelectedDishTags: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_dish_Dish_allSelectedDishTags_DishTagObject>
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_extraGroups_MenuItemExtraGroup_extras_MenuItemExtraGroupExtra = {
  __typename: 'MenuItemExtraGroupExtra',
  id: number,
  name: string,
  price?: number | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_extraGroups_MenuItemExtraGroup = {
  __typename: 'MenuItemExtraGroup',
  id: number,
  name: string,
  extras: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_extraGroups_MenuItemExtraGroup_extras_MenuItemExtraGroupExtra>
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_modifierGroups_MenuItemModifierGroup_modifiers_MenuItemModifierGroupModifier = {
  __typename: 'MenuItemModifierGroupModifier',
  id: number,
  modifierId?: number | null,
  price?: number | null,
  priceCustomText?: string | null,
  priceType: string
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_modifierGroups_MenuItemModifierGroup = {
  __typename: 'MenuItemModifierGroup',
  id: number,
  rootModifierGroupId?: number | null,
  modifiers: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_modifierGroups_MenuItemModifierGroup_modifiers_MenuItemModifierGroupModifier>
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_sharedExtraGroups_MenuItemSharedExtraGroup_sharedExtraGroup_SharedExtraGroup_extras_SharedExtraGroupExtra = {
  __typename: 'SharedExtraGroupExtra',
  id: number,
  name: string,
  price?: number | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_sharedExtraGroups_MenuItemSharedExtraGroup_sharedExtraGroup_SharedExtraGroup = {
  __typename: 'SharedExtraGroup',
  id: number,
  name: string,
  extras: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_sharedExtraGroups_MenuItemSharedExtraGroup_sharedExtraGroup_SharedExtraGroup_extras_SharedExtraGroupExtra>
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_sharedExtraGroups_MenuItemSharedExtraGroup = {
  __typename: 'MenuItemSharedExtraGroup',
  id: number,
  sharedExtraGroup?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_sharedExtraGroups_MenuItemSharedExtraGroup_sharedExtraGroup_SharedExtraGroup | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_extras_MenuItemExtra = {
  __typename: 'MenuItemExtra',
  id: number,
  name: string,
  price?: number | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_featuredPhoto_MenuItemPhoto = {
  __typename: 'MenuItemPhoto',
  id: number,
  photoUrl?: string | null,
  thumbnailUrl?: string | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_featuredPhoto_Photo = {
  __typename: 'Photo',
  id: number,
  photoUrl?: string | null,
  thumbnailUrl?: string | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_featuredPhoto = CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_featuredPhoto_MenuItemPhoto | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_featuredPhoto_Photo;

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_sizes_MenuItemSize = {
  __typename: 'MenuItemSize',
  id: number,
  name: string,
  price?: number | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem = {
  __typename: 'MenuItem',
  id: number,
  currency: string,
  cateringOrderMax?: number | null,
  cateringOrderMin?: number | null,
  customTaxRateId?: number | null,
  description?: string | null,
  dishId?: number | null,
  featured?: boolean | null,
  featuredPosition?: number | null,
  likedItPopsCount: number,
  lovedItPopsCount: number,
  hasMenuSyncWarning?: boolean | null,
  hasBlockingMenuSyncWarning?: boolean | null,
  isMenuSyncEnabled?: boolean | null,
  isToastProvider?: boolean | null,
  isEnabled?: boolean | null,
  isOrderingEnabled?: boolean | null,
  isOnSyncCompleted?: boolean | null,
  isPoppable?: boolean | null,
  isTaxable?: boolean | null,
  masterItemId?: number | null,
  name: string,
  outOfStock?: boolean | null,
  outOfStockUntil?: string | null,
  photosCount?: number | null,
  popsCount: number,
  price?: number | null,
  priceCustomText?: string | null,
  priceType?: string | null,
  restaurantId?: number | null,
  reviewsCount: number,
  showDisclaimer?: boolean | null,
  showFeaturedPhoto?: boolean | null,
  slug: string,
  wannaTryPopsCount: number,
  url?: string | null,
  uiItem?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_uiItem | null,
  availableExternalItems?: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_availableExternalItems_ExternalMenuItem> | null,
  section?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_section_MenuSection | null,
  subsection?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_subsection_MenuSubsection | null,
  menu: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_menu_Menu,
  dish?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_dish_Dish | null,
  extraGroups: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_extraGroups_MenuItemExtraGroup>,
  modifierGroups: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_modifierGroups_MenuItemModifierGroup>,
  sharedExtraGroups: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_sharedExtraGroups_MenuItemSharedExtraGroup>,
  extras: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_extras_MenuItemExtra>,
  featuredPhoto?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_featuredPhoto | null,
  sizes: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem_sizes_MenuItemSize>
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection = {
  __typename: 'MenuFeaturedSection',
  id: number,
  backgroundColor?: string | null,
  description?: string | null,
  isAccented: boolean,
  isEnabled: boolean,
  itemGenerationTriggered?: string | null,
  itemSource: string,
  layout?: string | null,
  name: string,
  items: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection_items_MenuItem>
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledSections_MenuSection = {
  __typename: 'MenuSection',
  id: number,
  enabledItemsCount: number,
  hasEnabledCustomHtml?: boolean | null,
  isEnabled: boolean,
  isHeaderEnabled: boolean,
  isOrderingSection: boolean,
  name: string,
  slug: string
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu = {
  __typename: 'Menu',
  id: number,
  isOrderingAvailable: boolean,
  backgroundColor?: string | null,
  backgroundEffect?: string | null,
  backgroundImageUrl?: string | null,
  cateringLeadTimeMinutes: number,
  isCateringMenu: boolean,
  isEnabled?: boolean | null,
  isOrderingDeliveryEnabled: boolean,
  isOrderingDineInEnabled?: boolean | null,
  isOrderingEnabled: boolean,
  locationId?: number | null,
  menuLayout?: string | null,
  name: string,
  photoUrl?: string | null,
  slug: string,
  url?: string | null,
  enabledFeaturedSection?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledFeaturedSection_MenuFeaturedSection | null,
  enabledSections: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu_enabledSections_MenuSection>
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeDeliveryRanges_MenuDeliveryOpeningRange = {
  __typename: 'MenuDeliveryOpeningRange',
  id: number,
  openTime?: number | null,
  closeTime?: number | null,
  days: Array<string>,
  daySunday?: boolean | null,
  dayMonday?: boolean | null,
  dayTuesday?: boolean | null,
  dayWednesday?: boolean | null,
  dayThursday?: boolean | null,
  dayFriday?: boolean | null,
  daySaturday?: boolean | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeDeliveryRanges_MenuDineInOpeningRange = {
  __typename: 'MenuDineInOpeningRange',
  id: number,
  openTime?: number | null,
  closeTime?: number | null,
  days: Array<string>,
  daySunday?: boolean | null,
  dayMonday?: boolean | null,
  dayTuesday?: boolean | null,
  dayWednesday?: boolean | null,
  dayThursday?: boolean | null,
  dayFriday?: boolean | null,
  daySaturday?: boolean | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeDeliveryRanges_MenuOrderingOpeningRange = {
  __typename: 'MenuOrderingOpeningRange',
  id: number,
  openTime?: number | null,
  closeTime?: number | null,
  days: Array<string>,
  daySunday?: boolean | null,
  dayMonday?: boolean | null,
  dayTuesday?: boolean | null,
  dayWednesday?: boolean | null,
  dayThursday?: boolean | null,
  dayFriday?: boolean | null,
  daySaturday?: boolean | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeDeliveryRanges_RestaurantLocationCateringDeliveryOpeningRange = {
  __typename: 'RestaurantLocationCateringDeliveryOpeningRange',
  id: number,
  openTime?: number | null,
  closeTime?: number | null,
  days: Array<string>,
  daySunday?: boolean | null,
  dayMonday?: boolean | null,
  dayTuesday?: boolean | null,
  dayWednesday?: boolean | null,
  dayThursday?: boolean | null,
  dayFriday?: boolean | null,
  daySaturday?: boolean | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeDeliveryRanges_RestaurantLocationCateringOrderingOpeningRange = {
  __typename: 'RestaurantLocationCateringOrderingOpeningRange',
  id: number,
  openTime?: number | null,
  closeTime?: number | null,
  days: Array<string>,
  daySunday?: boolean | null,
  dayMonday?: boolean | null,
  dayTuesday?: boolean | null,
  dayWednesday?: boolean | null,
  dayThursday?: boolean | null,
  dayFriday?: boolean | null,
  daySaturday?: boolean | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeDeliveryRanges_RestaurantLocationDeliveryOpeningRange = {
  __typename: 'RestaurantLocationDeliveryOpeningRange',
  id: number,
  openTime?: number | null,
  closeTime?: number | null,
  days: Array<string>,
  daySunday?: boolean | null,
  dayMonday?: boolean | null,
  dayTuesday?: boolean | null,
  dayWednesday?: boolean | null,
  dayThursday?: boolean | null,
  dayFriday?: boolean | null,
  daySaturday?: boolean | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeDeliveryRanges_RestaurantLocationDineInOpeningRange = {
  __typename: 'RestaurantLocationDineInOpeningRange',
  id: number,
  openTime?: number | null,
  closeTime?: number | null,
  days: Array<string>,
  daySunday?: boolean | null,
  dayMonday?: boolean | null,
  dayTuesday?: boolean | null,
  dayWednesday?: boolean | null,
  dayThursday?: boolean | null,
  dayFriday?: boolean | null,
  daySaturday?: boolean | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeDeliveryRanges_RestaurantLocationOpeningRange = {
  __typename: 'RestaurantLocationOpeningRange',
  id: number,
  openTime?: number | null,
  closeTime?: number | null,
  days: Array<string>,
  daySunday?: boolean | null,
  dayMonday?: boolean | null,
  dayTuesday?: boolean | null,
  dayWednesday?: boolean | null,
  dayThursday?: boolean | null,
  dayFriday?: boolean | null,
  daySaturday?: boolean | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeDeliveryRanges_RestaurantLocationOrderingOpeningRange = {
  __typename: 'RestaurantLocationOrderingOpeningRange',
  id: number,
  openTime?: number | null,
  closeTime?: number | null,
  days: Array<string>,
  daySunday?: boolean | null,
  dayMonday?: boolean | null,
  dayTuesday?: boolean | null,
  dayWednesday?: boolean | null,
  dayThursday?: boolean | null,
  dayFriday?: boolean | null,
  daySaturday?: boolean | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeDeliveryRanges_RestaurantLocationReservationsOpeningRange = {
  __typename: 'RestaurantLocationReservationsOpeningRange',
  id: number,
  openTime?: number | null,
  closeTime?: number | null,
  days: Array<string>,
  daySunday?: boolean | null,
  dayMonday?: boolean | null,
  dayTuesday?: boolean | null,
  dayWednesday?: boolean | null,
  dayThursday?: boolean | null,
  dayFriday?: boolean | null,
  daySaturday?: boolean | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeDeliveryRanges = CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeDeliveryRanges_MenuDeliveryOpeningRange | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeDeliveryRanges_MenuDineInOpeningRange | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeDeliveryRanges_MenuOrderingOpeningRange | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeDeliveryRanges_RestaurantLocationCateringDeliveryOpeningRange | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeDeliveryRanges_RestaurantLocationCateringOrderingOpeningRange | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeDeliveryRanges_RestaurantLocationDeliveryOpeningRange | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeDeliveryRanges_RestaurantLocationDineInOpeningRange | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeDeliveryRanges_RestaurantLocationOpeningRange | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeDeliveryRanges_RestaurantLocationOrderingOpeningRange | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeDeliveryRanges_RestaurantLocationReservationsOpeningRange;

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeOrderingRanges_MenuDeliveryOpeningRange = {
  __typename: 'MenuDeliveryOpeningRange',
  id: number,
  openTime?: number | null,
  closeTime?: number | null,
  days: Array<string>,
  daySunday?: boolean | null,
  dayMonday?: boolean | null,
  dayTuesday?: boolean | null,
  dayWednesday?: boolean | null,
  dayThursday?: boolean | null,
  dayFriday?: boolean | null,
  daySaturday?: boolean | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeOrderingRanges_MenuDineInOpeningRange = {
  __typename: 'MenuDineInOpeningRange',
  id: number,
  openTime?: number | null,
  closeTime?: number | null,
  days: Array<string>,
  daySunday?: boolean | null,
  dayMonday?: boolean | null,
  dayTuesday?: boolean | null,
  dayWednesday?: boolean | null,
  dayThursday?: boolean | null,
  dayFriday?: boolean | null,
  daySaturday?: boolean | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeOrderingRanges_MenuOrderingOpeningRange = {
  __typename: 'MenuOrderingOpeningRange',
  id: number,
  openTime?: number | null,
  closeTime?: number | null,
  days: Array<string>,
  daySunday?: boolean | null,
  dayMonday?: boolean | null,
  dayTuesday?: boolean | null,
  dayWednesday?: boolean | null,
  dayThursday?: boolean | null,
  dayFriday?: boolean | null,
  daySaturday?: boolean | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeOrderingRanges_RestaurantLocationCateringDeliveryOpeningRange = {
  __typename: 'RestaurantLocationCateringDeliveryOpeningRange',
  id: number,
  openTime?: number | null,
  closeTime?: number | null,
  days: Array<string>,
  daySunday?: boolean | null,
  dayMonday?: boolean | null,
  dayTuesday?: boolean | null,
  dayWednesday?: boolean | null,
  dayThursday?: boolean | null,
  dayFriday?: boolean | null,
  daySaturday?: boolean | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeOrderingRanges_RestaurantLocationCateringOrderingOpeningRange = {
  __typename: 'RestaurantLocationCateringOrderingOpeningRange',
  id: number,
  openTime?: number | null,
  closeTime?: number | null,
  days: Array<string>,
  daySunday?: boolean | null,
  dayMonday?: boolean | null,
  dayTuesday?: boolean | null,
  dayWednesday?: boolean | null,
  dayThursday?: boolean | null,
  dayFriday?: boolean | null,
  daySaturday?: boolean | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeOrderingRanges_RestaurantLocationDeliveryOpeningRange = {
  __typename: 'RestaurantLocationDeliveryOpeningRange',
  id: number,
  openTime?: number | null,
  closeTime?: number | null,
  days: Array<string>,
  daySunday?: boolean | null,
  dayMonday?: boolean | null,
  dayTuesday?: boolean | null,
  dayWednesday?: boolean | null,
  dayThursday?: boolean | null,
  dayFriday?: boolean | null,
  daySaturday?: boolean | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeOrderingRanges_RestaurantLocationDineInOpeningRange = {
  __typename: 'RestaurantLocationDineInOpeningRange',
  id: number,
  openTime?: number | null,
  closeTime?: number | null,
  days: Array<string>,
  daySunday?: boolean | null,
  dayMonday?: boolean | null,
  dayTuesday?: boolean | null,
  dayWednesday?: boolean | null,
  dayThursday?: boolean | null,
  dayFriday?: boolean | null,
  daySaturday?: boolean | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeOrderingRanges_RestaurantLocationOpeningRange = {
  __typename: 'RestaurantLocationOpeningRange',
  id: number,
  openTime?: number | null,
  closeTime?: number | null,
  days: Array<string>,
  daySunday?: boolean | null,
  dayMonday?: boolean | null,
  dayTuesday?: boolean | null,
  dayWednesday?: boolean | null,
  dayThursday?: boolean | null,
  dayFriday?: boolean | null,
  daySaturday?: boolean | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeOrderingRanges_RestaurantLocationOrderingOpeningRange = {
  __typename: 'RestaurantLocationOrderingOpeningRange',
  id: number,
  openTime?: number | null,
  closeTime?: number | null,
  days: Array<string>,
  daySunday?: boolean | null,
  dayMonday?: boolean | null,
  dayTuesday?: boolean | null,
  dayWednesday?: boolean | null,
  dayThursday?: boolean | null,
  dayFriday?: boolean | null,
  daySaturday?: boolean | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeOrderingRanges_RestaurantLocationReservationsOpeningRange = {
  __typename: 'RestaurantLocationReservationsOpeningRange',
  id: number,
  openTime?: number | null,
  closeTime?: number | null,
  days: Array<string>,
  daySunday?: boolean | null,
  dayMonday?: boolean | null,
  dayTuesday?: boolean | null,
  dayWednesday?: boolean | null,
  dayThursday?: boolean | null,
  dayFriday?: boolean | null,
  daySaturday?: boolean | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeOrderingRanges = CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeOrderingRanges_MenuDeliveryOpeningRange | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeOrderingRanges_MenuDineInOpeningRange | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeOrderingRanges_MenuOrderingOpeningRange | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeOrderingRanges_RestaurantLocationCateringDeliveryOpeningRange | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeOrderingRanges_RestaurantLocationCateringOrderingOpeningRange | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeOrderingRanges_RestaurantLocationDeliveryOpeningRange | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeOrderingRanges_RestaurantLocationDineInOpeningRange | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeOrderingRanges_RestaurantLocationOpeningRange | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeOrderingRanges_RestaurantLocationOrderingOpeningRange | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeOrderingRanges_RestaurantLocationReservationsOpeningRange;

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation = {
  __typename: 'RestaurantLocation',
  id: number,
  bagFeeAmount: number,
  cateringDeliveryTimeSlots: Array<string>,
  cateringOrderTimeSlots: Array<string>,
  cateringPickupMinMenuItemCartSubtotal?: number | null,
  cateringDeliveryMinMenuItemCartSubtotal?: number | null,
  country: string,
  curbsidePhone?: string | null,
  currency?: string | null,
  currentCateringDeliveryDueMinutes: number,
  currentCateringPickupDueMinutes: number,
  currentDeliveryDueMinutes: number,
  currentPickupDueMinutes: number,
  defaultDineInTabTip?: number | null,
  defaultPickupDueMinutes?: number | null,
  defaultTipOption?: number | null,
  deliveryType?: string | null,
  dineInSkipPaymentAllowed?: boolean | null,
  firstDayOfWeek?: string | null,
  fullAddress?: string | null,
  hasCateringMenu: boolean,
  hasDeliveryMenu: boolean,
  hasDineInMenu: boolean,
  hasNonCateringMenu: boolean,
  hasPickupMenu: boolean,
  hasToastGiftCardSupport: boolean,
  hasToastOfferSupport: boolean,
  heartlandPublicKey?: string | null,
  hideTaxesAndTipsDisclaimersOnPickup: boolean,
  isDeliveryAvailable: boolean,
  isBagFeeEnabled: boolean,
  isOrderingCateringDeliveryEnabled: boolean,
  isOrderingCateringEnabled: boolean,
  isCateringOrderingAvailable: boolean,
  isCateringDeliveryAvailable: boolean,
  isOrderingAvailable: boolean,
  isOrderingEnabled?: boolean | null,
  isOrderingCateringPayOnPickupEnabled: boolean,
  isOrderingConsumerPlatformFeeEnabled?: boolean | null,
  isOrderingDeliveryCoverMinimumEnabled?: boolean | null,
  isOrderingDeliveryEnabled: boolean,
  isOrderingDeliveryForCateringEnabled: boolean,
  isOrderingDeliveryPlatformFeeEnabled?: boolean | null,
  isOrderingDineInEnabled?: boolean | null,
  isOrderingDineInFeeEnabled?: boolean | null,
  isOrderingDineInHideEmailFieldEnabled?: boolean | null,
  isOrderingDineInHideNameFieldEnabled?: boolean | null,
  isOrderingDineInHidePaymentStepEnabled: boolean,
  isOrderingDineInHidePhoneNumberFieldEnabled?: boolean | null,
  isOrderingDineInPlatformFeeEnabled?: boolean | null,
  isOrderingDineInRemoveTableLabelEnabled: boolean,
  isOrderingFeeEnabled?: boolean | null,
  isOrderingScheduleEnabled?: boolean | null,
  isOrderingSpecialInstructionsEnabled?: boolean | null,
  isOrderingMessagesEnabled?: boolean | null,
  isOrderingMessagesForCateringEnabled?: boolean | null,
  isOrderingTextMessagesEnabled?: boolean | null,
  isOrderingTipsEnabled: boolean,
  isOrderingPayOnPickupEnabled?: boolean | null,
  isStripePaymentRequestButtonEnabled: boolean,
  isStripePaymentAvailable: boolean,
  isSquarePaymentRequestButtonEnabled: boolean,
  isSquarePaymentAvailable: boolean,
  isAuthorizePaymentAvailable: boolean,
  isCloverPaymentAvailable: boolean,
  isEverywarePaymentAvailable: boolean,
  isHeartlandPaymentAvailable: boolean,
  isToastPaymentAvailable: boolean,
  isOrderingPaymentEnabled?: boolean | null,
  isPickupCurbsideEnabled?: boolean | null,
  isPickupInStoreEnabled?: boolean | null,
  isStripePayment: boolean,
  isSquarePayment: boolean,
  isToastPayment: boolean,
  isCloverPayment: boolean,
  isEverywarePayment: boolean,
  isNcrSilverPayment: boolean,
  isAlohaPayment: boolean,
  isDeliverectPayment: boolean,
  isAuthorizePayment: boolean,
  isHeartlandPayment: boolean,
  isNcrSilverPaymentAvailable: boolean,
  isAlohaPaymentAvailable: boolean,
  isUkBased: boolean,
  lat?: number | null,
  lng?: number | null,
  name: string,
  orderingDineInTableNumberLabel?: string | null,
  orderingDineInTableNumberDescription?: string | null,
  orderingDelayMinutes?: number | null,
  orderingDelayUntil?: string | null,
  orderingDeliveryCoverMinimumAmount?: number | null,
  orderingDeliveryFeeAmount?: number | null,
  orderingDeliveryDriveTime?: number | null,
  orderingDeliveryMinMenuItemCartSubtotal?: number | null,
  orderingDineInIntroText?: string | null,
  orderingPaymentMessage?: string | null,
  orderingPickupMinMenuItemCartSubtotal?: number | null,
  orderTimeLaterOptionCustomLabel?: string | null,
  orderTypePickupOptionCustomLabel?: string | null,
  paymentMethod?: string | null,
  pickupCurbsideCustomLabel?: string | null,
  pickupCurbsideDescription?: string | null,
  pickupInStoreCustomLabel?: string | null,
  pickupInStoreDescription?: string | null,
  scheduledDeliveryTimeSlots: Array<string>,
  scheduledOrderTimeSlots: Array<string>,
  showCurbsideVehicleInputs?: boolean | null,
  squareApplicationId?: string | null,
  squareLocationId?: string | null,
  slug: string,
  stripePublishableKey?: string | null,
  enabledMenus: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_enabledMenus_Menu>,
  activeDeliveryRanges?: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeDeliveryRanges> | null,
  activeOrderingRanges?: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation_activeOrderingRanges> | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_applicableCustomFees_ApplicableCustomFees = {
  __typename: 'ApplicableCustomFees',
  finalAmount: number,
  name: string
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_uiMenuItemCart_UiMenuItemCartAloha = {
  __typename: 'UiMenuItemCartAloha',
  id: number,
  isGiftCardsAndOffersDisabled: boolean,
  isDoorDashDeliveryMissing: boolean,
  isUkBased: boolean,
  isValidateOnCheckoutLoad: boolean,
  showModifiersPrices: boolean
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_uiMenuItemCart_UiMenuItemCartBase = {
  __typename: 'UiMenuItemCartBase',
  id: number,
  isGiftCardsAndOffersDisabled: boolean,
  isDoorDashDeliveryMissing: boolean,
  isUkBased: boolean,
  isValidateOnCheckoutLoad: boolean,
  showModifiersPrices: boolean
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_uiMenuItemCart_UiMenuItemCartClover = {
  __typename: 'UiMenuItemCartClover',
  id: number,
  isGiftCardsAndOffersDisabled: boolean,
  isDoorDashDeliveryMissing: boolean,
  isUkBased: boolean,
  isValidateOnCheckoutLoad: boolean,
  showModifiersPrices: boolean
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_uiMenuItemCart_UiMenuItemCartDeliverect = {
  __typename: 'UiMenuItemCartDeliverect',
  id: number,
  isGiftCardsAndOffersDisabled: boolean,
  isDoorDashDeliveryMissing: boolean,
  isUkBased: boolean,
  isValidateOnCheckoutLoad: boolean,
  showModifiersPrices: boolean
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_uiMenuItemCart_UiMenuItemCartHeartland = {
  __typename: 'UiMenuItemCartHeartland',
  id: number,
  isGiftCardsAndOffersDisabled: boolean,
  isDoorDashDeliveryMissing: boolean,
  isUkBased: boolean,
  isValidateOnCheckoutLoad: boolean,
  showModifiersPrices: boolean
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_uiMenuItemCart_UiMenuItemCartHeartlandPos = {
  __typename: 'UiMenuItemCartHeartlandPos',
  id: number,
  isGiftCardsAndOffersDisabled: boolean,
  isDoorDashDeliveryMissing: boolean,
  isUkBased: boolean,
  isValidateOnCheckoutLoad: boolean,
  showModifiersPrices: boolean
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_uiMenuItemCart_UiMenuItemCartMicros = {
  __typename: 'UiMenuItemCartMicros',
  id: number,
  isGiftCardsAndOffersDisabled: boolean,
  isDoorDashDeliveryMissing: boolean,
  isUkBased: boolean,
  isValidateOnCheckoutLoad: boolean,
  showModifiersPrices: boolean
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_uiMenuItemCart_UiMenuItemCartNcrSilver = {
  __typename: 'UiMenuItemCartNcrSilver',
  id: number,
  isGiftCardsAndOffersDisabled: boolean,
  isDoorDashDeliveryMissing: boolean,
  isUkBased: boolean,
  isValidateOnCheckoutLoad: boolean,
  showModifiersPrices: boolean
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_uiMenuItemCart_UiMenuItemCartSquare = {
  __typename: 'UiMenuItemCartSquare',
  id: number,
  isGiftCardsAndOffersDisabled: boolean,
  isDoorDashDeliveryMissing: boolean,
  isUkBased: boolean,
  isValidateOnCheckoutLoad: boolean,
  showModifiersPrices: boolean
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_uiMenuItemCart_UiMenuItemCartStripe = {
  __typename: 'UiMenuItemCartStripe',
  id: number,
  isGiftCardsAndOffersDisabled: boolean,
  isDoorDashDeliveryMissing: boolean,
  isUkBased: boolean,
  isValidateOnCheckoutLoad: boolean,
  showModifiersPrices: boolean
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_uiMenuItemCart_UiMenuItemCartToast = {
  __typename: 'UiMenuItemCartToast',
  id: number,
  isGiftCardsAndOffersDisabled: boolean,
  isDoorDashDeliveryMissing: boolean,
  isUkBased: boolean,
  isValidateOnCheckoutLoad: boolean,
  showModifiersPrices: boolean
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_uiMenuItemCart = CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_uiMenuItemCart_UiMenuItemCartAloha | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_uiMenuItemCart_UiMenuItemCartBase | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_uiMenuItemCart_UiMenuItemCartClover | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_uiMenuItemCart_UiMenuItemCartDeliverect | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_uiMenuItemCart_UiMenuItemCartHeartland | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_uiMenuItemCart_UiMenuItemCartHeartlandPos | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_uiMenuItemCart_UiMenuItemCartMicros | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_uiMenuItemCart_UiMenuItemCartNcrSilver | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_uiMenuItemCart_UiMenuItemCartSquare | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_uiMenuItemCart_UiMenuItemCartStripe | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_uiMenuItemCart_UiMenuItemCartToast;

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_orderingEvent_OrderingEvent_location_RestaurantLocation = {
  __typename: 'RestaurantLocation',
  id: number,
  timezone?: string | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_orderingEvent_OrderingEvent = {
  __typename: 'OrderingEvent',
  id: number,
  eventDate: string,
  minOrdersCount?: number | null,
  name: string,
  pickupType?: string | null,
  pickupStartTime: number,
  orderingEventTimeSlots: Array<string>,
  location?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_orderingEvent_OrderingEvent_location_RestaurantLocation | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedEcard_MenuItemCartSelectedEcard = {
  __typename: 'MenuItemCartSelectedEcard',
  id: number,
  originalBalance?: number | null,
  menuItemCartId: number,
  endingBalance?: number | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedGiftCard_MenuItemCartSelectedGiftCard_giftCard_GiftCard = {
  __typename: 'GiftCard',
  id: number,
  amount: number,
  lastFour?: string | null,
  originalAmount: number
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedGiftCard_MenuItemCartSelectedGiftCard = {
  __typename: 'MenuItemCartSelectedGiftCard',
  id: number,
  amount?: number | null,
  menuItemCartId: number,
  giftCardId?: number | null,
  giftCard?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedGiftCard_MenuItemCartSelectedGiftCard_giftCard_GiftCard | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_menuItem_MenuItem_featuredPhoto_MenuItemPhoto = {
  __typename: 'MenuItemPhoto',
  id: number,
  photoUrl?: string | null,
  thumbnailUrl?: string | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_menuItem_MenuItem_featuredPhoto_Photo = {
  __typename: 'Photo',
  id: number,
  photoUrl?: string | null,
  thumbnailUrl?: string | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_menuItem_MenuItem_featuredPhoto = CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_menuItem_MenuItem_featuredPhoto_MenuItemPhoto | CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_menuItem_MenuItem_featuredPhoto_Photo;

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_menuItem_MenuItem_menu_Menu = {
  __typename: 'Menu',
  id: number,
  masterMenuId?: number | null,
  slug: string
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_menuItem_MenuItem_section_MenuSection = {
  __typename: 'MenuSection',
  id: number,
  masterSectionId?: number | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_menuItem_MenuItem = {
  __typename: 'MenuItem',
  id: number,
  currency: string,
  dishId?: number | null,
  featuredPhoto?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_menuItem_MenuItem_featuredPhoto | null,
  menu: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_menuItem_MenuItem_menu_Menu,
  section?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_menuItem_MenuItem_section_MenuSection | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_invalidFlatSelectedModifiers_MenuItemCartSelectedMenuItemSelectedModifierGroupSelectedModifier = {
  __typename: 'MenuItemCartSelectedMenuItemSelectedModifierGroupSelectedModifier',
  id: number,
  message?: string | null,
  modifierName?: string | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_selectedExtras_MenuItemCartSelectedMenuItemSelectedExtra = {
  __typename: 'MenuItemCartSelectedMenuItemSelectedExtra',
  id: number,
  menuItemExtraId?: number | null,
  menuItemExtraName?: string | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_selectedExtraGroups_MenuItemCartSelectedMenuItemSelectedExtraGroup_selectedExtras_MenuItemCartSelectedMenuItemSelectedExtraGroupSelectedExtra = {
  __typename: 'MenuItemCartSelectedMenuItemSelectedExtraGroupSelectedExtra',
  id: number,
  extraId?: number | null,
  extraName?: string | null,
  quantity: number
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_selectedExtraGroups_MenuItemCartSelectedMenuItemSelectedExtraGroup = {
  __typename: 'MenuItemCartSelectedMenuItemSelectedExtraGroup',
  id: number,
  menuItemExtraGroupId?: number | null,
  selectedExtras: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_selectedExtraGroups_MenuItemCartSelectedMenuItemSelectedExtraGroup_selectedExtras_MenuItemCartSelectedMenuItemSelectedExtraGroupSelectedExtra>
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_selectedModifierGroups_MenuItemCartSelectedMenuItemSelectedModifierGroup_selectedModifiers_MenuItemCartSelectedMenuItemSelectedModifierGroupSelectedModifier_selectedModifierGroups_MenuItemCartSelectedMenuItemSelectedModifierGroup_selectedModifiers_MenuItemCartSelectedMenuItemSelectedModifierGroupSelectedModifier = {
  __typename: 'MenuItemCartSelectedMenuItemSelectedModifierGroupSelectedModifier',
  id: number,
  modifierName?: string | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_selectedModifierGroups_MenuItemCartSelectedMenuItemSelectedModifierGroup_selectedModifiers_MenuItemCartSelectedMenuItemSelectedModifierGroupSelectedModifier_selectedModifierGroups_MenuItemCartSelectedMenuItemSelectedModifierGroup = {
  __typename: 'MenuItemCartSelectedMenuItemSelectedModifierGroup',
  id: number,
  menuItemModifierGroupName?: string | null,
  selectedModifiers: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_selectedModifierGroups_MenuItemCartSelectedMenuItemSelectedModifierGroup_selectedModifiers_MenuItemCartSelectedMenuItemSelectedModifierGroupSelectedModifier_selectedModifierGroups_MenuItemCartSelectedMenuItemSelectedModifierGroup_selectedModifiers_MenuItemCartSelectedMenuItemSelectedModifierGroupSelectedModifier>
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_selectedModifierGroups_MenuItemCartSelectedMenuItemSelectedModifierGroup_selectedModifiers_MenuItemCartSelectedMenuItemSelectedModifierGroupSelectedModifier = {
  __typename: 'MenuItemCartSelectedMenuItemSelectedModifierGroupSelectedModifier',
  id: number,
  menuItemModifierId?: number | null,
  modifierName?: string | null,
  modifierPrice?: number | null,
  quantity: number,
  selectedModifierGroups: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_selectedModifierGroups_MenuItemCartSelectedMenuItemSelectedModifierGroup_selectedModifiers_MenuItemCartSelectedMenuItemSelectedModifierGroupSelectedModifier_selectedModifierGroups_MenuItemCartSelectedMenuItemSelectedModifierGroup>
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_selectedModifierGroups_MenuItemCartSelectedMenuItemSelectedModifierGroup = {
  __typename: 'MenuItemCartSelectedMenuItemSelectedModifierGroup',
  id: number,
  menuItemModifierGroupId?: number | null,
  menuItemModifierGroupName?: string | null,
  selectedModifiers: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_selectedModifierGroups_MenuItemCartSelectedMenuItemSelectedModifierGroup_selectedModifiers_MenuItemCartSelectedMenuItemSelectedModifierGroupSelectedModifier>
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_selectedSharedExtraGroups_MenuItemCartSelectedMenuItemSelectedSharedExtraGroup_selectedExtras_MenuItemCartSelectedMenuItemSelectedSharedExtraGroupSelectedExtra = {
  __typename: 'MenuItemCartSelectedMenuItemSelectedSharedExtraGroupSelectedExtra',
  id: number,
  extraId?: number | null,
  extraName?: string | null,
  quantity: number
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_selectedSharedExtraGroups_MenuItemCartSelectedMenuItemSelectedSharedExtraGroup = {
  __typename: 'MenuItemCartSelectedMenuItemSelectedSharedExtraGroup',
  id: number,
  sharedExtraGroupId?: number | null,
  selectedExtras: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_selectedSharedExtraGroups_MenuItemCartSelectedMenuItemSelectedSharedExtraGroup_selectedExtras_MenuItemCartSelectedMenuItemSelectedSharedExtraGroupSelectedExtra>
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_uiSelectedMenuItem_UiSelectedMenuItemBase = {
  __typename: 'UiSelectedMenuItemBase',
  id: number,
  isValidItemAndModifiers: boolean
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem = {
  __typename: 'MenuItemCartSelectedMenuItem',
  adjustedMenuItemPrice?: number | null,
  posMenuItemPriceOverride?: number | null,
  id: number,
  isVoid?: boolean | null,
  isValid?: boolean | null,
  message?: string | null,
  menuItemId?: number | null,
  menuItemName?: string | null,
  offerId?: number | null,
  discountAmount?: number | null,
  price?: number | null,
  profileEventTracking?: string | null,
  quantity: number,
  selectedMenuItemSizeId?: number | null,
  selectedMenuItemSizeName?: string | null,
  subtotal?: number | null,
  summaryExtended?: string | null,
  menuItem?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_menuItem_MenuItem | null,
  invalidFlatSelectedModifiers: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_invalidFlatSelectedModifiers_MenuItemCartSelectedMenuItemSelectedModifierGroupSelectedModifier>,
  selectedExtras: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_selectedExtras_MenuItemCartSelectedMenuItemSelectedExtra>,
  selectedExtraGroups: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_selectedExtraGroups_MenuItemCartSelectedMenuItemSelectedExtraGroup>,
  selectedModifierGroups: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_selectedModifierGroups_MenuItemCartSelectedMenuItemSelectedModifierGroup>,
  selectedSharedExtraGroups: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_selectedSharedExtraGroups_MenuItemCartSelectedMenuItemSelectedSharedExtraGroup>,
  uiSelectedMenuItem: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_uiSelectedMenuItem_UiSelectedMenuItemBase
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode_orderingOffer_OrderingOffer_orderingOfferBxgyDetail_OrderingOfferBxgyDetail_applicableDishes_OrderingOfferBxgyDish_dish_Dish_items_MenuItem_menu_Menu_location_RestaurantLocation = {
  __typename: 'RestaurantLocation',
  id: number,
  name: string
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode_orderingOffer_OrderingOffer_orderingOfferBxgyDetail_OrderingOfferBxgyDetail_applicableDishes_OrderingOfferBxgyDish_dish_Dish_items_MenuItem_menu_Menu = {
  __typename: 'Menu',
  id: number,
  location?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode_orderingOffer_OrderingOffer_orderingOfferBxgyDetail_OrderingOfferBxgyDetail_applicableDishes_OrderingOfferBxgyDish_dish_Dish_items_MenuItem_menu_Menu_location_RestaurantLocation | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode_orderingOffer_OrderingOffer_orderingOfferBxgyDetail_OrderingOfferBxgyDetail_applicableDishes_OrderingOfferBxgyDish_dish_Dish_items_MenuItem = {
  __typename: 'MenuItem',
  id: number,
  name: string,
  menu: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode_orderingOffer_OrderingOffer_orderingOfferBxgyDetail_OrderingOfferBxgyDetail_applicableDishes_OrderingOfferBxgyDish_dish_Dish_items_MenuItem_menu_Menu
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode_orderingOffer_OrderingOffer_orderingOfferBxgyDetail_OrderingOfferBxgyDetail_applicableDishes_OrderingOfferBxgyDish_dish_Dish = {
  __typename: 'Dish',
  id: number,
  name: string,
  items: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode_orderingOffer_OrderingOffer_orderingOfferBxgyDetail_OrderingOfferBxgyDetail_applicableDishes_OrderingOfferBxgyDish_dish_Dish_items_MenuItem>
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode_orderingOffer_OrderingOffer_orderingOfferBxgyDetail_OrderingOfferBxgyDetail_applicableDishes_OrderingOfferBxgyDish = {
  __typename: 'OrderingOfferBxgyDish',
  id: number,
  dishType: string,
  dish?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode_orderingOffer_OrderingOffer_orderingOfferBxgyDetail_OrderingOfferBxgyDetail_applicableDishes_OrderingOfferBxgyDish_dish_Dish | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode_orderingOffer_OrderingOffer_orderingOfferBxgyDetail_OrderingOfferBxgyDetail_redeemableDishes_OrderingOfferBxgyDish_dish_Dish_items_MenuItem_menu_Menu_location_RestaurantLocation = {
  __typename: 'RestaurantLocation',
  id: number,
  name: string
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode_orderingOffer_OrderingOffer_orderingOfferBxgyDetail_OrderingOfferBxgyDetail_redeemableDishes_OrderingOfferBxgyDish_dish_Dish_items_MenuItem_menu_Menu = {
  __typename: 'Menu',
  id: number,
  location?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode_orderingOffer_OrderingOffer_orderingOfferBxgyDetail_OrderingOfferBxgyDetail_redeemableDishes_OrderingOfferBxgyDish_dish_Dish_items_MenuItem_menu_Menu_location_RestaurantLocation | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode_orderingOffer_OrderingOffer_orderingOfferBxgyDetail_OrderingOfferBxgyDetail_redeemableDishes_OrderingOfferBxgyDish_dish_Dish_items_MenuItem = {
  __typename: 'MenuItem',
  id: number,
  name: string,
  menu: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode_orderingOffer_OrderingOffer_orderingOfferBxgyDetail_OrderingOfferBxgyDetail_redeemableDishes_OrderingOfferBxgyDish_dish_Dish_items_MenuItem_menu_Menu
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode_orderingOffer_OrderingOffer_orderingOfferBxgyDetail_OrderingOfferBxgyDetail_redeemableDishes_OrderingOfferBxgyDish_dish_Dish = {
  __typename: 'Dish',
  id: number,
  name: string,
  items: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode_orderingOffer_OrderingOffer_orderingOfferBxgyDetail_OrderingOfferBxgyDetail_redeemableDishes_OrderingOfferBxgyDish_dish_Dish_items_MenuItem>
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode_orderingOffer_OrderingOffer_orderingOfferBxgyDetail_OrderingOfferBxgyDetail_redeemableDishes_OrderingOfferBxgyDish = {
  __typename: 'OrderingOfferBxgyDish',
  id: number,
  dishType: string,
  dish?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode_orderingOffer_OrderingOffer_orderingOfferBxgyDetail_OrderingOfferBxgyDetail_redeemableDishes_OrderingOfferBxgyDish_dish_Dish | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode_orderingOffer_OrderingOffer_orderingOfferBxgyDetail_OrderingOfferBxgyDetail = {
  __typename: 'OrderingOfferBxgyDetail',
  id: number,
  bxgyType: string,
  applicableQuantity?: number | null,
  redeemableQuantity?: number | null,
  applicableDishes?: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode_orderingOffer_OrderingOffer_orderingOfferBxgyDetail_OrderingOfferBxgyDetail_applicableDishes_OrderingOfferBxgyDish> | null,
  redeemableDishes: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode_orderingOffer_OrderingOffer_orderingOfferBxgyDetail_OrderingOfferBxgyDetail_redeemableDishes_OrderingOfferBxgyDish>
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode_orderingOffer_OrderingOffer = {
  __typename: 'OrderingOffer',
  id: number,
  menuId?: number | null,
  sectionId?: number | null,
  sectionName?: string | null,
  dishId?: number | null,
  offerAppliedTo?: string | null,
  offerType?: string | null,
  orderingOfferBxgyDetail?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode_orderingOffer_OrderingOffer_orderingOfferBxgyDetail_OrderingOfferBxgyDetail | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode_orderingOfferSchedule_OrderingOfferSchedule = {
  __typename: 'OrderingOfferSchedule',
  id: number,
  startDate?: string | null,
  startTime?: number | null,
  endDate?: string | null,
  endTime?: number | null,
  isRecurring?: boolean | null,
  recurringType?: string | null,
  repeatsEvery?: number | null,
  recurringMonthDay?: number | null,
  openAllDay?: boolean | null,
  daySunday?: boolean | null,
  dayMonday?: boolean | null,
  dayTuesday?: boolean | null,
  dayWednesday?: boolean | null,
  dayThursday?: boolean | null,
  daySaturday?: boolean | null,
  dayFriday?: boolean | null,
  friendlySchedule?: string | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode = {
  __typename: 'OrderingOfferCode',
  id: number,
  code?: string | null,
  orderingOfferExpirationDate?: string | null,
  orderingOfferMinimumOrderAmount: number,
  orderingOfferIsOnetimeUse: boolean,
  orderingOfferIsOnetimeUsePerOrder: boolean,
  orderingOffer?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode_orderingOffer_OrderingOffer | null,
  orderingOfferSchedule?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode_orderingOfferSchedule_OrderingOfferSchedule | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode = {
  __typename: 'MenuItemCartSelectedOrderingOfferCode',
  id: number,
  amount?: number | null,
  code?: string | null,
  locationName?: string | null,
  originalAmount?: number | null,
  originalMinimumOrderAmount?: number | null,
  menuItemCartId: number,
  offerType?: string | null,
  offerName?: string | null,
  orderingOfferCodeId?: number | null,
  orderingOfferCode?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode_orderingOfferCode_OrderingOfferCode | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_subcarts_MenuItemCartSubcart_selectedMenuItems_MenuItemCartSelectedMenuItem = {
  __typename: 'MenuItemCartSelectedMenuItem',
  adjustedMenuItemPrice?: number | null,
  posMenuItemPriceOverride?: number | null,
  id: number,
  isVoid?: boolean | null,
  isValid?: boolean | null,
  message?: string | null,
  menuItemId?: number | null,
  menuItemName?: string | null,
  offerId?: number | null,
  discountAmount?: number | null,
  price?: number | null,
  profileEventTracking?: string | null,
  quantity: number,
  selectedMenuItemSizeId?: number | null,
  selectedMenuItemSizeName?: string | null,
  subtotal?: number | null,
  summaryExtended?: string | null,
  menuItem?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_menuItem_MenuItem | null,
  invalidFlatSelectedModifiers: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_invalidFlatSelectedModifiers_MenuItemCartSelectedMenuItemSelectedModifierGroupSelectedModifier>,
  selectedExtras: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_selectedExtras_MenuItemCartSelectedMenuItemSelectedExtra>,
  selectedExtraGroups: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_selectedExtraGroups_MenuItemCartSelectedMenuItemSelectedExtraGroup>,
  selectedModifierGroups: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_selectedModifierGroups_MenuItemCartSelectedMenuItemSelectedModifierGroup>,
  selectedSharedExtraGroups: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_selectedSharedExtraGroups_MenuItemCartSelectedMenuItemSelectedSharedExtraGroup>,
  uiSelectedMenuItem: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem_uiSelectedMenuItem_UiSelectedMenuItemBase
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_subcarts_MenuItemCartSubcart = {
  __typename: 'MenuItemCartSubcart',
  id: number,
  status?: string | null,
  subtotal?: number | null,
  selectedMenuItems: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_subcarts_MenuItemCartSubcart_selectedMenuItems_MenuItemCartSelectedMenuItem>
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart = {
  __typename: 'MenuItemCart',
  onlineBagFeeAmount?: number | null,
  id: number,
  capturedAt?: string | null,
  cartType?: string | null,
  cloverApiKey?: string | null,
  cloverTipAmount?: number | null,
  containsAlcohol?: boolean | null,
  deliveryAddressNumber?: string | null,
  deliveryCity?: string | null,
  deliveryFeeAmount?: number | null,
  deliveryFullAddress?: string | null,
  deliveryAddressWithoutNumber?: string | null,
  deliveryInstructionsMaxLength?: number | null,
  deliveryInstructionsMinLength: number,
  doordashNameMaxLength?: number | null,
  deliveryPostalCode?: string | null,
  deliveryState?: string | null,
  deliveryStreetAddress?: string | null,
  dineInTableLabel: string,
  dineInTableNumber?: string | null,
  discountAmount?: number | null,
  email?: string | null,
  enableEmailNotifications?: boolean | null,
  enableTextMessageNotifications?: boolean | null,
  fulfillmentType: string,
  hasPayment?: boolean | null,
  canBalanceBeFullyPaidByThirdPartyGiftCard: boolean,
  giftCardDiscountAmount?: number | null,
  hasGiftCard: boolean,
  isPosSubmitConfirmationRequired?: boolean | null,
  isPosValidationConfirmationRequired?: boolean | null,
  isPosOrderValidated?: boolean | null,
  isPosOfferFailed?: boolean | null,
  isLastSubcartSubmitted?: boolean | null,
  isScheduled?: boolean | null,
  isSubmitted?: boolean | null,
  isTabClosedConsumer?: boolean | null,
  isTabOpened?: boolean | null,
  isDoordashDelivery: boolean,
  lastSubcartSubmittedAt?: string | null,
  message?: string | null,
  name?: string | null,
  paymentMethod?: string | null,
  onlinePayment: boolean,
  paymentDescription?: string | null,
  paymentStatus?: string | null,
  phone?: string | null,
  pickupType?: string | null,
  pickupVehicleColor?: string | null,
  pickupVehicleMakeModel?: string | null,
  platformFeeAmount?: number | null,
  profileEventTracking?: Array<string> | null,
  scheduledAt?: string | null,
  showNotificationSettings: boolean,
  specialInstructionsMaxLength?: number | null,
  specialInstructionsMinLength: number,
  status?: string | null,
  subtotal?: number | null,
  subtotalForOffer?: number | null,
  onlineFeeAmount?: number | null,
  onlineTaxAmount?: number | null,
  onlineTipAmount?: number | null,
  stripeTipAmount?: number | null,
  squareTipAmount?: number | null,
  toastTipAmount?: number | null,
  ncrSilverTipAmount?: number | null,
  location?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_location_RestaurantLocation | null,
  applicableCustomFees: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_applicableCustomFees_ApplicableCustomFees>,
  uiMenuItemCart: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_uiMenuItemCart,
  orderingEvent?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_orderingEvent_OrderingEvent | null,
  selectedEcard?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedEcard_MenuItemCartSelectedEcard | null,
  selectedGiftCard?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedGiftCard_MenuItemCartSelectedGiftCard | null,
  selectedMenuItems: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedMenuItems_MenuItemCartSelectedMenuItem>,
  selectedOrderingOfferCode?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_selectedOrderingOfferCode_MenuItemCartSelectedOrderingOfferCode | null,
  subcarts: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart_subcarts_MenuItemCartSubcart>
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_calendarEventPops_CalendarEventPop = {
  __typename: 'CalendarEventPop',
  calendarEventId?: number | null,
  id: number,
  popType?: string | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_pops_Pop = {
  __typename: 'Pop',
  id: number,
  dishableId?: number | null,
  dishableType?: string | null,
  popType: string
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_reviews_Review = {
  __typename: 'Review',
  id: number,
  dishableId?: number | null,
  dishableType?: string | null,
  content?: string | null,
  locationId?: number | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_reviewUpvotes_ReviewUpvote = {
  __typename: 'ReviewUpvote',
  id: number,
  reviewId?: number | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_user_User_calendarEventPops_CalendarEventPop = {
  __typename: 'CalendarEventPop',
  id: number,
  calendarEventId?: number | null,
  popType?: string | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_user_User_pops_Pop = {
  __typename: 'Pop',
  id: number,
  dishableId?: number | null,
  dishableType?: string | null,
  popType: string
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_user_User_reviews_Review_restaurant_Restaurant = {
  __typename: 'Restaurant',
  id: number
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_user_User_reviews_Review = {
  __typename: 'Review',
  id: number,
  dishableId?: number | null,
  dishableType?: string | null,
  content?: string | null,
  locationId?: number | null,
  restaurant?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_user_User_reviews_Review_restaurant_Restaurant | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_user_User_reviewUpvotes_ReviewUpvote = {
  __typename: 'ReviewUpvote',
  id: number,
  reviewId?: number | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_user_User_followers_Follower_favoriteLocation_RestaurantLocation = {
  __typename: 'RestaurantLocation',
  id: number,
  slug: string
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_user_User_followers_Follower = {
  __typename: 'Follower',
  id: number,
  isSmsUnsubscribed?: boolean | null,
  isUnsubscribed?: boolean | null,
  restaurantId: number,
  favoriteLocation?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_user_User_followers_Follower_favoriteLocation_RestaurantLocation | null
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session_user_User = {
  __typename: 'User',
  id: number,
  adminPaletteType?: string | null,
  currentSignInAt?: string | null,
  orderAudioType?: string | null,
  authyStatus?: string | null,
  avatarUrl?: string | null,
  birthDay?: number | null,
  birthMonth?: number | null,
  createdAt?: string | null,
  displayName: string,
  email?: string | null,
  firstName?: string | null,
  fullName?: string | null,
  isPendingPassword?: boolean | null,
  isRoot: boolean,
  isRootStaging: boolean,
  isSmsUnsubscribed?: boolean | null,
  isTextValidated: boolean,
  isUnsubscribed?: boolean | null,
  lastFourDigitsPhoneNumber?: string | null,
  lastName?: string | null,
  phone?: string | null,
  isMobilePhone?: boolean | null,
  thumbnailUrl?: string | null,
  userRole?: string | null,
  calendarEventPops?: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_user_User_calendarEventPops_CalendarEventPop> | null,
  pops: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_user_User_pops_Pop>,
  reviews: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_user_User_reviews_Review>,
  reviewUpvotes: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_user_User_reviewUpvotes_ReviewUpvote>,
  followers: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_user_User_followers_Follower>
};

export type CurrentSessionWithMenuItemCartQuery_currentSession_Session = {
  __typename: 'Session',
  id: string,
  avatarUrl?: string | null,
  isAuthyRequired: boolean,
  isAuthyVerified: boolean,
  isSoftAuthenticated: boolean,
  pendingMenuItemCart?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_pendingMenuItemCart_MenuItemCart | null,
  calendarEventPops: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_calendarEventPops_CalendarEventPop>,
  pops: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_pops_Pop>,
  reviews: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_reviews_Review>,
  reviewUpvotes: Array<CurrentSessionWithMenuItemCartQuery_currentSession_Session_reviewUpvotes_ReviewUpvote>,
  user?: CurrentSessionWithMenuItemCartQuery_currentSession_Session_user_User | null
};

export type CurrentSessionWithMenuItemCartQuery_Query = {
  __typename?: 'Query',
  currentSession: CurrentSessionWithMenuItemCartQuery_currentSession_Session
};


export type CurrentSessionWithMenuItemCartQueryVariables = Types.Exact<{
  cartType: Types.Scalars['String']['input'];
  locationId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  orderingEventId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  cartRestaurantId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  fulfillmentType?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CurrentSessionWithMenuItemCartQuery = CurrentSessionWithMenuItemCartQuery_Query;


export const CurrentSessionWithMenuItemCartDocument = /*#__PURE__*/ document as unknown as DocumentNode<CurrentSessionWithMenuItemCartQuery, CurrentSessionWithMenuItemCartQueryVariables>;


/**
 * __useCurrentSessionWithMenuItemCartQuery__
 *
 * To run a query within a React component, call `useCurrentSessionWithMenuItemCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentSessionWithMenuItemCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param options options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentSessionWithMenuItemCartQuery({
 *   variables: {
 *      cartType: // value for 'cartType'
 *      locationId: // value for 'locationId'
 *      orderingEventId: // value for 'orderingEventId'
 *      cartRestaurantId: // value for 'cartRestaurantId'
 *      fulfillmentType: // value for 'fulfillmentType'
 *   },
 * });
 */
export function useCurrentSessionWithMenuItemCartQuery(options: ApolloReactHooks.QueryHookOptions<CurrentSessionWithMenuItemCartQuery, CurrentSessionWithMenuItemCartQueryVariables> & ({ variables: CurrentSessionWithMenuItemCartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
                return ApolloReactHooks.useQuery<CurrentSessionWithMenuItemCartQuery, CurrentSessionWithMenuItemCartQueryVariables>(CurrentSessionWithMenuItemCartDocument, options);
      }
export function useCurrentSessionWithMenuItemCartLazyQuery(options?: ApolloReactHooks.LazyQueryHookOptions<CurrentSessionWithMenuItemCartQuery, CurrentSessionWithMenuItemCartQueryVariables>) {
                    return ApolloReactHooks.useLazyQuery<CurrentSessionWithMenuItemCartQuery, CurrentSessionWithMenuItemCartQueryVariables>(CurrentSessionWithMenuItemCartDocument, options);
        }
export function useCurrentSessionWithMenuItemCartSuspenseQuery(options?: ApolloReactHooks.SuspenseQueryHookOptions<CurrentSessionWithMenuItemCartQuery, CurrentSessionWithMenuItemCartQueryVariables>) {
                    return ApolloReactHooks.useSuspenseQuery<CurrentSessionWithMenuItemCartQuery, CurrentSessionWithMenuItemCartQueryVariables>(CurrentSessionWithMenuItemCartDocument, options);
        }
export type CurrentSessionWithMenuItemCartQueryHookResult = ReturnType<typeof useCurrentSessionWithMenuItemCartQuery>;
export type CurrentSessionWithMenuItemCartLazyQueryHookResult = ReturnType<typeof useCurrentSessionWithMenuItemCartLazyQuery>;
export type CurrentSessionWithMenuItemCartSuspenseQueryHookResult = ReturnType<typeof useCurrentSessionWithMenuItemCartSuspenseQuery>;
export type CurrentSessionWithMenuItemCartQueryResult = ApolloReactCommon.QueryResult<CurrentSessionWithMenuItemCartQuery, CurrentSessionWithMenuItemCartQueryVariables>;